import styled from 'styled-components'

const SkonsolidowanePolaczenieSpolekStyleV12 = styled.div`
  .checkbox {
    height: 56px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    padding-left: 25px;
  }

  .element {
    background: #fff;
    border-radius: 3px;
    padding: 8px 0 20px 0;
    margin-bottom: 4px;
  }

  .element:hover {
    border-left: 5px solid ${props => props.theme.palette.primary.main};
    > div {
      padding-left: 20px;
    }
  }

  .radioGroup {
    display: flex;
    justify-content: space-between;
    padding-left: 25px;
  }

  .nazwaJednostki {
    display: flex;
    justify-content: space-between; 
    align-items: center;
    padding-left: 25px;
    padding-right: 20px;

    .text {
      width: 100%;
    }
  }

  .szczegolyPolaczenia{
    width: 100%;
    height: 36px;
    background: ${props => props.theme.black4onBlack4};
    padding: 12px 20px 10px 25px;
    font-family: 'Ubuntu';
    font-size: 11px;
    color: ${props => props.theme.black38};
    margin: 12px 0 0 0;

    p {
      margin: auto;
    }
  }

  .metoda {
    padding-left: 25px;
    padding-right: 20px;
  }

`
export default SkonsolidowanePolaczenieSpolekStyleV12
